import React, { useEffect, useRef } from "react";

import lottie from "lottie-web";
import animationData from "../../social/assets/Loading2.json";

const FullScreenLoader2 = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const animation = lottie.loadAnimation({
      container: containerRef.current,
      animationData: animationData,
      loop: true,
      autoplay: true,
    });

    return () => {
      animation.destroy();
    };
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-300 bg-opacity-10">
      <div className="flex flex-col items-center justify-center h-screen w-screen z-50">
        <div ref={containerRef} />
        <p className="text-black text-xl mt-4">
          Please wait while it's loading...
        </p>
      </div>
    </div>
  );
};

export default FullScreenLoader2;
